import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { CHECKOUT_STEP_MAP, SHIP_OPTIONS_STEP } from 'constants/checkoutFlow';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import RightArrow from 'components/checkout/caap/RightArrow';
import styles from 'styles/components/checkout/caap/shipoption/shippingOptions.scss';

const ShippingOptions = ({ formatPrice, purchaseId, shipmentSpeed, shippingCharge, shipPromise }, { testId }) => {
  if (!shipmentSpeed) {
    return null;
  }

  return (
    <Row mobileOnly={true} extraClass={styles.changeShipOptionRow}>
      <Link
        role="link" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
        tabIndex="0"
        to={`${CHECKOUT_STEP_MAP[SHIP_OPTIONS_STEP]}?referrer=spc&pid=${purchaseId}`}
        data-te="TE_CHECKOUT_SPC_CHANGE_SHIP_OPT"
        data-test-id={testId('shipOptionLink')}>
        <Row>
          <RowSpan span="9">
            {`${shipPromise} ${formatPrice(shippingCharge)}`}
          </RowSpan>
          <RowSpan span="3">
            <RightArrow />
          </RowSpan>
        </Row>
      </Link>
    </Row>
  );
};

ShippingOptions.contextTypes = {
  testId: PropTypes.func
};

export default ShippingOptions;
